<kendo-gridlayout class="request-report"
  [cols]="['','']"
  [gap]="{ rows: 8, cols: 8 }"
  >

  <kendo-gridlayout-item [col]="1" [colSpan]="2" [rowSpan]="2">
    <div class="example-box" style="display:flex; justify-content: space-between; flex-wrap: wrap;">
      <div>
        <!-- Read:
        <a href="https://learn.flowstudio.app/full-text-search" target="learn">FlowStudio for Teams</a>&nbsp; -->
      </div>
      <div>
        <span class="text-sm text-slate-500">Flows (Request) is a <span class="pro-box"></span> subscription feature</span>
      </div>
    </div>
  </kendo-gridlayout-item>

  <kendo-gridlayout-item [col]="1" [colSpan]="2" [rowSpan]="2">
    <div style="padding:8px;"><b>Flows (Request) Report</b></div>

    <ul>
      <li>
        This report shows flows that use the "When an HTTP request is received" trigger. These flows can be triggered externally via HTTP requests, making them suitable for integration scenarios.
      </li>
      <li>
        First we do a scan of all the environments ({{ environment_current() }}/{{ environments()?.length }}) and find all your flows that use this trigger. This may take a few minutes depending on the number of environments and flows. ({{ flows_http_request()?.length }}/{{ flows()?.length }})
      </li>
      <li>
        Then for each flow we will need to check the flow definition to extract the request URL and method.  ({{flow_http_current()}}/{{flows_http_request()?.length}})
      </li>
      <li>
        We also need to check the flow's run history to see if it has been triggered recently. This will help us identify active flows.  We check the last run to see if it was invoked from the new or old URL. ({{flow_http_current()}} checked)
      </li>
    </ul>

    <!-- <div style="text-decoration: underline; cursor:pointer;" (click)="downloadCsv()">
    Download Links for details
  </div> -->
</kendo-gridlayout-item>

<kendo-gridlayout-item [col]="1" [colSpan]="2" [rowSpan]="2">
  <kendo-toolbar [overflow]='true' [size]="'small'">
    <kendo-toolbar-button kendoButton (click)="load()" [disabled]="loading()" [text]="loading() ? 'Loading...' : 'Load Report'"></kendo-toolbar-button>
    <kendo-toolbar-button kendoButton (click)="downloadCsv()" [disabled]="flows_http_request()?.length==0 || loading()" text="Export Excel"></kendo-toolbar-button>
  </kendo-toolbar>
  <kendo-grid class="request-report__grid"
    #grid
    [data]="flows_http_request()"
    [style.height]="'100%'"
    [sortable]="true"
    [pageable]="true"
    [pageSize]="20"
    >
    <kendo-grid-column field="environment" title="Environment" [width]="200" [filterable]="true" [sortable]="true">
    </kendo-grid-column>
    <kendo-grid-column field="displayName" title="Flow Name" [width]="250" [filterable]="true" [sortable]="true">
      <ng-template kendoGridCellTemplate let-dataItem>
        <a [href]="this.apiRoot + dataItem.portalUrl" target="_blank">{{dataItem.displayName}}</a>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="triggerKind" title="Trigger Kind" [width]="150">
    </kendo-grid-column>
    <kendo-grid-column field="flowState" title="State" [width]="150" [filterable]="true" [sortable]="true">
    </kendo-grid-column>
    <kendo-grid-column field="triggerMethod" title="Req Method" [width]="120" [filterable]="true" [sortable]="true">
    </kendo-grid-column>
    <kendo-grid-column field="triggerUrl" title="Req URL" [filterable]="true" [sortable]="true">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem.triggerUrl" target="_blank">{{dataItem.triggerUrl}}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="deprecatedTriggerUrl" title="Old URL" [filterable]="true" [sortable]="true">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem.deprecatedTriggerUrl" target="_blank">{{dataItem.deprecatedTriggerUrl}}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="lastRun" title="Last Run" [width]="200" [filterable]="true" [sortable]="true">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.lastRun ? (dataItem.lastRun | date:'yyyy-MM-dd HH:mm:ss') : 'Never' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="lastRunTriggerUrlChecked" title="Checked" [width]="100" [filterable]="true" [sortable]="true">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.lastRunTriggerUrlChecked === true ? 'New ✅' : null }}
        {{ dataItem.lastRunTriggerUrlChecked === false ? 'Old ⚠️' : null }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="lastRunTriggerCaller" title="Caller" [filterable]="true" [sortable]="true">
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (dataItem.lastRunTriggerCaller; as caller) {
          <!-- If it starts with http/https, render an anchor -->
          @if (caller.startsWith('http')) {
            <a
              [href]="caller"
              target="_blank"
              rel="noopener noreferrer"
              [title]="caller">
              {{ caller }}
            </a>
          }
          <!-- Otherwise render a span -->
          @if (!caller.startsWith('http')) {
            <span [title]="caller">
              {{ caller }}
            </span>
          }
        }
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="runsEstimateText" title="Estimate" [width]="200"  [filterable]="true" [sortable]="true">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.runsEstimateText }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-excel fileName="flow-http-requests.xlsx"></kendo-grid-excel>
  </kendo-grid>
</kendo-gridlayout-item>

</kendo-gridlayout>
